import ProminentPassengerCount from "./ProminentPassengerCount";
import TemporaryDrawer from "./TemporaryDrawer";

const AgentMarkHeader = (props: PropType) => {
  const { passengerCount } = props;
  return (
    <>
      <TemporaryDrawer />
      <ProminentPassengerCount passengerCount={passengerCount} />
    </>
  );
};

interface PropType {
  passengerCount: string;
}

export default AgentMarkHeader;
